import { createSlice } from "@reduxjs/toolkit";

export const adminInmersys = createSlice({
	name: "adminInmersys",
	initialState: {
		enterprises: [],
	},
	reducers: {
		addEnterprises: (state, { payload }) => {
			state.enterprises = payload;
			console.log("epresas", state.enterprises);
		},
		deleteOneEnterpise: (state, { payload }) => {
			state.enterprises = state.enterprises.filter((ent) => ent._id !== payload.id);
		},
	},
});

export const { addEnterprises, deleteOneEnterpise } = adminInmersys.actions;
